import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getLocalizedRoutePath, ROUTE_KEYS } from "../../routes/definitions";

export default function Error({ type }) {
    const errorMessage = type === "404" ? "erro 404 - recurso nao encontrado" : "erro interno";
    const navigate = useNavigate();
    const { i18n } = useTranslation();

    return (
        <main className="flex flex-col h-screen">
            <div
                className="m-auto flex flex-col text-center gap-5 justify-center cursor-pointer"
                onClick={() => navigate(getLocalizedRoutePath(ROUTE_KEYS.LOGIN, i18n.language))}
            >
                <FontAwesomeIcon className="h-32 w-32 p-2 self-center" color="#042ad8" icon={faWarning} />
                <b className="text-2xl">{errorMessage}</b>
            </div>
        </main>
    );
}

